import {
  CREATE_CAMPAIGN_EFFECT,
  CREATE_CAMPAIGN_EFFECT_SUCCESS,
  CREATE_CAMPAIGN_EFFECT_ERROR,
  CREATE_CAMPAIGN_EFFECT_EMPTY,
} from './../../../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const CreateCampaignEffect = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_CAMPAIGN_EFFECT:
      state = {
        ...state,
        data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case CREATE_CAMPAIGN_EFFECT_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case CREATE_CAMPAIGN_EFFECT_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case CREATE_CAMPAIGN_EFFECT_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default CreateCampaignEffect;
